import {
  Text,
  Drawer as ChakraDrawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  List,
  ListItem,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import useWindowSize from "../utils/useWindowSize";
import { useTranslation } from "react-i18next";
import PermissionGuard from "./security/PermissionGuard";
import { NavLinkProp } from "./Layout";

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  btnRef: React.MutableRefObject<any>;
  colorMode: string;
  links: NavLinkProp[];
};

interface DrawerListElementProps {
  colorMode: string;
  icon: any;
  name: string;
  action: () => void;
  link: string;
}

const DrawerListElement = (props: DrawerListElementProps) => {

  return (
    <ListItem
      color={"black"}
      backgroundColor={window.location.pathname === props.link ? "green.100" : ""}
      onClick={props.action}
      className={`flex flex-row items-center hover:bg-gray-100 py-3 px-6 rounded-[20px]`}
    >
      {props.icon}
      <Text className='ml-4' fontSize='lg'>{props.name}</Text>
    </ListItem>
  )
}

const Drawer = (props: DrawerProps) => {
  const {
    isOpen,
    onClose,
    btnRef,
    colorMode,
    links
  } = props;
  const { t } = useTranslation("translations");
  const nav = useNavigate();
  const { width } = useWindowSize();

  return (
    <ChakraDrawer
      isOpen={isOpen}
      placement='left'
      onClose={onClose}
      finalFocusRef={btnRef}
      size={width < 780 ? "full" : "sm"}
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>{t("MENU")}</DrawerHeader>
        <DrawerBody>
          <List spacing={6}>
            {
              links.map((link, index) => (
                <PermissionGuard key={`link_top_${index}`} permissions={link.permissions}>
                  <DrawerListElement
                    key={`DrawerListElement_${index}`}
                    colorMode={colorMode}
                    icon={link.icon}
                    name={t(link.name)}
                    link={link.link}
                    action={() => nav(link.link)}
                  />
                </PermissionGuard>
              ))
            }
          </List>
        </DrawerBody>
      </DrawerContent>
    </ChakraDrawer>
  )
};

export default Drawer;